import { toURL } from '../reducers/util';
import { cohortApiUrl } from "./api";
import {AppThunk} from "../configureStore";
import {
  ICD10_IPDN_TREE_URL,
  ICD10_TREE_URL,
  PROCEDURE_IPDN_TREE_URL,
  PROCEDURE_TREE_URL
} from "../common/CommonConstants";

// settings
export function getSettings(keys: string[]): AppThunk {
  return (dispatch) => {
    const keysToGet = keys.join(",")
    const url = `${cohortApiUrl()}/settings?key=${keysToGet}`
    return fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: process.env.NODE_ENV === "development" ? "include" : "same-origin"
    })
      .then(response => response.json())
      .then(settings => {
        dispatch(setSettings(settings))
      })
        .catch(console.error)

  }
}
export const setSettings = (settings:any) => ({
  type: 'SET_SETTINGS',
  settings
})

// diagnosis tree
export function getICD10Tree(): AppThunk  {
  return (dispatch) => {
    const url = toURL(ICD10_TREE_URL, true)
    return fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: process.env.NODE_ENV === "development" ? "include" : "same-origin"
    })
      .then(
        response => response.json()
      )
      .then(data => {
        dispatch(setICD10Tree(data))
      })
        .catch(console.error)
  }
}

export function getICD10IPDNTree(): AppThunk {
  return (dispatch) => {
    const url = toURL(ICD10_IPDN_TREE_URL, true)
    return fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: process.env.NODE_ENV === "development" ? "include" : "same-origin"
    })
        .then(
            response => response.json()
        )
        .then(data => {
          dispatch(setICD10IPDNTree(data))
        })
        .catch(console.error)

  }
}

export const setICD10Tree = (icd10tree: any) => ({
  type: 'SET_ICD10TREE',
  icd10tree
})

export const setICD10IPDNTree = (icd10IPDNTree: any) => ({
  type: 'SET_ICD10IPDNTREE',
  icd10IPDNTree
})

// procedure tree
export function getProcedureTree(): AppThunk {
  return (dispatch, getState) => {
    const url = toURL(PROCEDURE_TREE_URL, true)
    return fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: process.env.NODE_ENV === "development" ? "include" : "same-origin"
    })
      .then(
        response => response.json()
      )
      .then(data => {
        dispatch(setProcedureTree(data))
      })
        .catch(console.error)


  }
}

export function getProcedureIPDNTree(): AppThunk {
  return (dispatch, getState) => {
    const url = toURL(PROCEDURE_IPDN_TREE_URL, true)
    return fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: process.env.NODE_ENV === "development" ? "include" : "same-origin"
    })
        .then(
            response => response.json()
        )
        .then(data => {
          dispatch(setProcedureIPDNTree(data))
        })
        .catch(console.error)

  }
}

export const setProcedureTree = (procedureTree: any) => ({
  type: 'SET_PROCEDURETREE',
  procedureTree
})

export const setProcedureIPDNTree = (procedureIPDNTree: any) => ({
  type: 'SET_PROCEDUREIPDNTREE',
  procedureIPDNTree
})